import React, { useEffect, useState } from "react";
import IndianCurrency from "./Svg/IndianCurrency";
import Silverlogo from "./Svg/Silverlogo";
import BoxForPrice from "./SilverBoxForPrice";
import BuyGoldPrice from "./BuyGoldPrice";
import PlatinumPrice from "./PlatinumPrice";
import axios from "axios";
import { useCookies } from "react-cookie";
import Package from "../../Api/Package";
import ProductCategoryApi from "../../Api/ProductCategoryApi";
import "./../../CSS/Responsive.css";

const PricingPage = () => {
  const [allcategory, setallcategory] = useState([
    "Category 1",
    "Category 2",
    "Category 3",
  ]);
  const [CurrentCategory, setCurrentCategory] = useState(1);
  const [CurrentPackge, setCurrentPackge] = useState([]);
  const [cookies] = useCookies(["token"]);

  const fetchCategory = async () => {
    try {
      
      const result = await ProductCategoryApi.GetProductCategory();
      console.log(`result: ${result}`);
      if (result.StatusCode == 200) {
        setallcategory(result.Result);
      }
      FetchPackage(result.Result[0]?.id)
    } catch (error) {
      console.log(error);
    }
  };

  const FetchPackage = async (categoryId) => {
    try {
      
      if (!categoryId) {
        return;
      }
      const result = await Package.GetAllPackage();
      console.log(`result: ${result}`);
      if (result.StatusCode == 200) {
        const allPackge = result.Result;
        const FilterWithCategoryId = allPackge?.filter(
          (item) => item.categoryId == categoryId
        );
        setCurrentCategory(categoryId);
        setCurrentPackge(FilterWithCategoryId);
      }
    } catch (error) {
      console.log(error);
    }
  };

  let lastScroll = window.pageYOffset;
  const fncforscrooll = (e) => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (lastScroll > scrollTop) {
      // Scrolling up
      const id = document.getElementById("row");
      id.style.transition = "all 200ms";
      id.style.top = "0px"; // Move down when scrolling up
    } else {
      // Scrolling down
      const id = document.getElementById("row");
      id.style.transition = "all 200ms";
      id.style.top = "-90px"; // Move up when scrolling down
    }

    lastScroll = scrollTop;
  };

  window.addEventListener("scroll", fncforscrooll);

  const scrollLeft = () => {
    const twoBoxPricing = document.querySelector(".two-box-pricing"); 
    twoBoxPricing.scrollLeft += 500;  
  };

  const scrollRight = () => {
    const twoBoxPricing = document.querySelector(".two-box-pricing"); 
    twoBoxPricing.scrollLeft -= 500;  
  };

 

  useEffect(() => {
    console.log(`Current Packge`, CurrentPackge);
  }, [CurrentPackge]);

  useEffect(() => {
    fetchCategory();
  }, []);

  return (
    <div className={`category-page`}>
      {/* ------------category------------ */}
      <ul id="row" className={`category-button`}>
        {allcategory.map((item, index) => {
          return (
            <li
              key={index}
              onClick={() => FetchPackage(item?.id)}
              value={item?.id}
              className={CurrentCategory == item.id ? "active-category" : ""}
            >
              {item?.name}
            </li>
          );
        })}
      </ul>

      {/* ----------pricing-------------- */}
      <div className="Flex-general-client-sidebar pricing-main">
        <div className={`pricing-top`}>
          <div className={`pricing-text`}>
            <div className={`plan-and-price`}>
              <span>Plan</span>
              <span>&</span>
              <span>Pricing</span>
            </div>
            <p className={`choose-text`}>
              Choose a plan that suits for your business
            </p>
          </div>
        </div>

        <div className={`div-and-forward-move`}>
          <div onClick={()=> scrollRight()} className={`forward-move forward-back`}>{"<"}</div>
          <div className={`two-box-pricing`}>
            {CurrentPackge.map((item, index) => {
              // let randomnumber;
              // const randomnumber = Math.floor(Math.random() * 3) + 1;
              // if(index<2){
              //   randomnumber=index+1
              // }else{
              //   randomnumber
              // }
              // const color =
              //   randomnumber === 1
              //     ? "#e6cef3"
              //     : randomnumber === 2
              //     ? "#caeef9"
              //     : randomnumber === 3
              //     ? "#e2e7ed"
              //     : null;
              // if (randomnumber == 1 && item?.IsActive) {
              return (
                <BoxForPrice
                  Price={item?.price}
                  MaxPrice={item?.max_amount}
                  Title={item?.name}
                  Benifits={item?.TextContent}
                  Discout={item?.minSalePrice}
                  backgroundcolor={"#caeef9"}
                />
              );
              // } else if (randomnumber == 2 && item?.IsActive) {
              //   return (
              //     <BuyGoldPrice
              //       Price={item?.price}
              //       MaxPrice={item?.max_amount}
              //       Title={item?.name}
              //       Benifits={item?.TextContent}
              //       Discout={item?.minSalePrice}
              //     />
              //   );
              // } else if (randomnumber == 3 && item?.IsActive) {
              //   return (
              //     <PlatinumPrice
              //       Price={item?.price}
              //       MaxPrice={item?.max_amount}
              //       Title={item?.name}
              //       Benifits={item?.TextContent}
              //       Discout={item?.minSalePrice}
              //     />
              //   );
              // }
            })}
            {/* --forwarwd- */}

            {CurrentPackge.length == 0 && CurrentCategory == 0 ? (
              <span className={`no-packge-msg`}>
                <span>Select Any Category For See Plan & Price</span>
              </span>
            ) : null}

            {CurrentPackge.length == 0 && CurrentCategory != 0 ? (
              <span className={`no-packge-msg`}>
                <span>Category Have No Plan & Price</span>
              </span>
            ) : null}
          </div>
          <div onClick={()=>scrollLeft()} className={`forward-move`}>{">"}</div>
        </div>
      </div>
    </div>
  );
};

export default PricingPage;
